import { useCallback } from 'react'
import { EventEmitter } from 'events'

const eventEmitter = new EventEmitter()
const eventName = 'refiner-event'

export default function useRefinerEvent() {
  const subscribe = useCallback(
    (callback: (data: any) => void) => {
      eventEmitter.addListener(eventName, callback)
    },
    [eventEmitter]
  )

  const publish = useCallback(
    (data: any) => {
      eventEmitter.emit(eventName, data)
    },
    [eventEmitter]
  )

  const destroy = useCallback(() => {
    eventEmitter.removeAllListeners()
  }, [eventEmitter])

  return {
    subscribe,
    destroy,
    publish,
  }
}
